module.exports = __webpack_public_path__ + "media/images/google-play-logo-fab964309f919e2d77d6bd77819148fc.png";